import { useParams } from 'react-router-dom';
import { getRandomArray } from '../../../utils/getRandomArray/getRandomArray';
import { getRandomRangeArray } from '../../../utils/getRandomRangeArray/getRandomRangeArray';
import color from '../../../data/color/color.json';
import styles from '../Museum.module.scss';

export const Bokey = ({ upPage }) => {
  const { lang } = useParams();
  const { toptitle, title, text, items } = upPage.acf.bokey;
  const upRanColArr = getRandomArray(color.length, items.length);
  const upRanArr = getRandomRangeArray(4, 7, items.length);

  return (
    <section className={styles.bokey}>
      <div className="container">
        <div className={styles.bokey_body}>
          <div id="come" className={styles.bokey_query}></div>
          <h3 className={`${styles.bokey_toptitle} global-subtitle`}>{toptitle[lang]}</h3>
          <h2 className={`${styles.bokey_title} global-title`}>{title[lang]}</h2>
          <p className={`${styles.bokey_text} global-text`}>{text[lang]}</p>
          <div className={styles.bokey_row}>
            {items.map((el, idx) => {
              const { icon, title, items } = el;
              return (
                <div key={idx} className={styles.bokey_column}>
                  <div className={styles.bokey_column_body}>
                    <div className={styles.bokey_column_wallpaper} style={{ background: color[upRanColArr[idx]] }}></div>
                    <div className={styles.bokey_column_icon}>
                      <div
                        style={{
                          animation: `${styles.bounce} ${upRanArr[idx]}s ease-in-out infinite`,
                        }}
                      >
                        {icon}
                      </div>
                    </div>
                    <h4 className={styles.bokey_column_title}>{title[lang]}</h4>
                    {!el.items ? (
                      <a href="https://bokeylibrary.kz" target="_black" className={`${styles.bokey_column_link} global-text`}>
                        bokeylibrary.kz
                      </a>
                    ) : (
                      items.map((el, idx) => {
                        return (
                          <p key={idx} className={`${styles.bokey_column_text} global-text`}>
                            {el[lang]}
                          </p>
                        );
                      })
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
